import { ConfigMap } from '../avenues/ConnectedCollectionAvenue';

export const AVENUE_CONFIGS = {
    bookmarks: {
        sorting: [{ id: 'title', desc: false }],
        facets: {
            title_lc: [{ value: 'Ousq', operator: 'contains' }],
        },
    },
    recents: {
        sorting: [{ id: 'lastUpdated', desc: true }],
    },
    all: {
        sorting: [{ id: 'title', desc: false }],
    },
} satisfies ConfigMap;
